import { createFileRoute } from '@tanstack/react-router'
import { SetupGuidePage } from '@/pages/compliance/SetupGuidePage'

/** RFC-231 — the Setup guide. Admin-gated inside the page; always routable. */
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/guide')({
  component: SetupGuidePage,
  staticData: {
    pageHeader: { title: 'Getting started', pad: false },
  },
})
